<template>
  <div class="features__group" :class="{ 'features__group--specs': specs }">
    <div v-if="!specs" class="flex flex-wrap">
      <div
        class="w-12/12 px-gap accordion__features-title pl-[56px] flex flex-row items-center accordion--open pt-1"
        :class="length > 2 ? 'md:w-3/12' : 'md:w-4/12'"
      >
        <div
          v-if="featureGroup.fields.description"
          class="align-text-bottom relative"
        >
          <svg
            class="inline mr-1/4 relative"
            :class="featureGroup.fields.description ? 'cursor-pointer' : ''"
            v-on="
              featureGroup.fields.description
                ? {
                    mouseenter: () => (open = !open),
                    mouseleave: () => (open = !open),
                  }
                : {}
            "
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.16663 14.1667H10.8333V9.16675H9.16663V14.1667ZM9.99996 1.66675C5.39996 1.66675 1.66663 5.40008 1.66663 10.0001C1.66663 14.6001 5.39996 18.3334 9.99996 18.3334C14.6 18.3334 18.3333 14.6001 18.3333 10.0001C18.3333 5.40008 14.6 1.66675 9.99996 1.66675ZM9.99996 16.6667C6.32496 16.6667 3.33329 13.6751 3.33329 10.0001C3.33329 6.32508 6.32496 3.33341 9.99996 3.33341C13.675 3.33341 16.6666 6.32508 16.6666 10.0001C16.6666 13.6751 13.675 16.6667 9.99996 16.6667ZM9.16663 7.50008H10.8333V5.83342H9.16663V7.50008Z"
              fill="#00263E"
            />
          </svg>
          <Tooltip
            v-show="open === true"
            :content="get(featureGroup, 'fields.description', '')"
          />
        </div>
        <h4 class="mb-1/2 text-blue-dark font-bold">
          {{ get(featureGroup, "fields.groupLabel", false) }}
        </h4>
      </div>
      <div
        v-for="(feature, index) in product"
        :key="index + 'feature'"
        class="hidden-m table__filler border-b-1 border-blue-default"
        :class="[length === 1 && '!w-8/12', length > 2 ? 'w-3/12' : 'w-4/12', feature.fields.productKey !== activeProduct.key ? 'bg-white' : 'bg-blue-light']"
      ></div>
    </div>
    <div class="flex flex-wrap">
      <template v-for="(feature, i) in featureGroup.fields.specsfeatures">
        <ProductFeatureLabel
          :key="i + 'feature-label'"
          :feature="feature"
          :length="length"
          :i="i"
          :specs="specs"
          :expand-all="expandTooltip"
        />
        <template v-for="(features, productIndex) in group">
          <div
            :key="i + productIndex"
            class="column px-gap py-1 m-0 flex items-start justify-center"
            :class="setColumns(i, productIndex, features.fields.productKey)"
          >
            <div
              v-if="features.fields.specfeatureGroup[index] &&
                features.fields.specfeatureGroup[index].fields && 
                features.fields.specfeatureGroup[index].fields.specsfeatures[i] &&
                features.fields.specfeatureGroup[index].fields.specsfeatures[i].fields && 
                features.fields.specfeatureGroup[index].fields.specsfeatures[i].fields.featureContent"
              class="wrapper__content"
            >
              <RichTextRenderer
                :document="features.fields.specfeatureGroup[index].fields.specsfeatures[i].fields.featureContent"
                :node-renderers="renderNodes()"
                :mark-renderers="renderMarks()"
              />
            </div>
            <div v-else class="text-center">
              <svg
                v-if="
                  features.fields.specfeatureGroup[index] &&
                  features.fields.specfeatureGroup[index].fields && 
                  features.fields.specfeatureGroup[index].fields.specsfeatures[i] &&
                  features.fields.specfeatureGroup[index].fields.specsfeatures[i].fields && 
                  features.fields.specfeatureGroup[index].fields.specsfeatures[i].fields.featureExists === false
                "
                class="inline"
                width="16"
                height="4"
                viewBox="0 0 16 4"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="16" height="4" fill="#C1C9D1" />
              </svg>
              <svg
                v-else-if="
                  features.fields.specfeatureGroup[index] &&
                  features.fields.specfeatureGroup[index].fields && 
                  features.fields.specfeatureGroup[index].fields.specsfeatures[i] &&
                  features.fields.specfeatureGroup[index].fields.specsfeatures[i].fields && 
                  features.fields.specfeatureGroup[index].fields.specsfeatures[i].fields.featureExists === true
                "
                class="inline"
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="6" cy="6" r="6" fill="#00263E" />
              </svg>
            </div>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.accordion__features-title {
  border-bottom: 1px solid #0184fb;

  svg {
    margin-left: -40px;
  }
}
.features__group {
  border-color: #c4c4c4;

  .column {
    margin: 0;

    p {
      margin-bottom: 0;
    }
  }
}
.features__group--specs {
  .column:not(.label--specs) {
    padding-top: 35px;
    padding-bottom: 0;
    p {
      margin-bottom: 20px;
    }

    h5:not(:first-of-type) {
      margin-top: 35px;
    }

    @media (min-width: 736px) {
      padding: 50px 0;
    }
  }
  .wrapper__content {
    h5 {
      color: #00263e;
      text-transform: none;
    }
    p {
      color: #00263e;
      font-size: 18px;
    }
    @media (min-width: 736px) {
      padding-left: 70px;
      padding-right: 30px;
    }
  }
}
.background--light-gray {
  background: rgba(#c4c4c4, 0.15);
}
h4 {
  @media (max-width: 736px) {
    font-size: 20px;
  }
}
</style>
<script>
import get from "../mixins/get.js";
import RichTextRenderer from "contentful-rich-text-vue-renderer";
import EntryRenderer from "../modules/EntryRenderer";
import ProductFeatureLabel from "../components/ProductFeatureLabel.vue";
import Tooltip from "./Tooltip.vue";

export default {
  components: {
    RichTextRenderer,
    ProductFeatureLabel,
    Tooltip,
  },
  mixins: [get, EntryRenderer],
  props: {
    product: {
      type: Object,
      required: true,
    },
    featureGroup: {
      type: Object,
      required: true,
    },
    length: {
      type: Number,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    activeProduct: {
      type: Object,
      required: true,
    },
    specs: {
      type: Boolean,
      required: false,
      default: false,
    },
    group: {
      type: [Object, Array],
      required: true,
    },
  },
  data() {
    return {
      open: false,
      expandTooltip: false,
    };
  },
  methods: {
    setColumns(i, productIndex, productKey) {
      return [
        this.length === 2 ? "w-[40vw] md:w-4/12" : (this.length === 1 ? "w-12/12 md:w-8/12" : (this.length > 2 ? "w-[40vw] md:w-3/12" : "w-12/12 md:w-8/12")),
        i % 2 !== 0 && !this.specs ? "bg-gray-neutral-100" : "",
        this.activeProduct && (productKey === this.activeProduct.key) ? "bg-blue-light" : "",
        !this.specs && productIndex === 0 ? "md:border-r-0" : "",
        !this.specs ? "border-gray-neutral-250 border-b-1" : "border-gray-neutral-250 border-t-1",
      ];
    },
  },
};
</script>
